import { useState } from 'react';
import './Faq.css';
import preguntas from './preguntas.json';

const Faq = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFaq = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className='faq container' id='faq-section'>
      <h2 className='faq-header'>
        <span className='lancaster-color'>Preguntas</span> <br />
        <span className='lancaster-color'>Frecuentes</span>
      </h2>
      
      <div className='faq-wrap'>
        {preguntas.map((item, index) => (
          <div className={`faq-item ${activeIndex === index ? 'active' : ''}`} key={index}>
            <div className='faq-item-header-wrap' onClick={() => toggleFaq(index)}>
              <h3 className='faq-item-header'>
                {item.pregunta}
              </h3>
              <div className='faq-item-arrow'>+</div>
            </div>
            <p className={`faq-item-paragraph ${activeIndex === index ? 'show' : 'hide'}`}>
              {item.respuesta}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Faq;
